import React from 'react';
import { cueListAsHTML } from '../../helpers/video';
import { MustacheWithHtml } from '../templating/MustacheWithHtml';
export default function DynamicText({ track, hasStarted, }) {
    const [cues, setCues] = React.useState(null);
    track.oncuechange = () => {
        if (track) {
            const { activeCues } = track;
            setCues(cueListAsHTML(activeCues));
        }
    };
    return (React.createElement("div", { className: `dynamic-text-wrapper ${hasStarted ? 'playing' : 'not-playing'}`, "data-testid": "dynamic-text-wrapper" },
        React.createElement(MustacheWithHtml, { template: cues || '' })));
}
//# sourceMappingURL=DynamicText.js.map